import {publishProductAddedToCart, publishProductRemovedFromCart} from './customer-events';

const labCart = (() => {
  function getKitFormData(form) {
    const formData = new FormData(form);
    const ids = Array.from(formData.getAll('id[]'));
    const kitKey = formData.get('properties[_KitKey]');
    const kitOptionalAccessoryPrice = formData.get('properties[_KitOptionalAccessoryPrice]');
    const kitItemType = Array.from(formData.getAll('properties[_KitItemType]'));
    const kitAllocatedCosts = Array.from(formData.getAll('properties[_KitAllocatedCost]'));
    const kitUniqueKeys = Array.from(formData.getAll('properties[_KitUniqueKey]'));
    const kitItemPrices = Array.from(formData.getAll('properties[_KitItemPrice]'));
    const kitCompareAtPrice = formData.get('properties[_KitCompareAtPrice]');
    const kitName = formData.get(`properties[${theme.translations.product_kit_line_item_part_of}]`);
    const kitOptionalProductStandardPrice = Array.from(
      formData.getAll('properties[_KitOptionalProductStandardPrice]')
    );
    const kitDeliverableAt = formData.get(`properties[${theme.translations.cart_deliverable_at}]`);

    const items = ids.map((id, index) => {
      const item = {
        id,
        quantity: 1,
        properties: {},
      };

      const parentVariant = index === 0;
      const itemsOrAccessories = index >= 1 && index <= kitItemType.length;
      const optionalItems = index > kitItemType.length;

      if (parentVariant || itemsOrAccessories) {
        item.properties._KitKey = kitKey;
      }

      if (parentVariant) {
        item.properties._KitParentVariant = true;
        if (kitCompareAtPrice) {
          item.properties._KitCompareAtPrice = kitCompareAtPrice;
        }
        if (kitOptionalAccessoryPrice) {
          item.properties._KitOptionalAccessoryPrice = kitOptionalAccessoryPrice;
        }
      }

      if (itemsOrAccessories) {
        item.properties._KitItemType = kitItemType[index - 1];
        item.properties._KitUniqueKey = kitUniqueKeys[index - 1];
        item.properties._KitItemPrice = kitItemPrices[index - 1];
        item.properties._KitAllocatedCost = kitAllocatedCosts[index - 1];
        item.properties[theme.translations.product_kit_line_item_part_of] = kitName;
      }

      if (optionalItems) {
        item.properties._KitOptionalProductStandardPrice =
          kitOptionalProductStandardPrice[index - 1 - kitItemType.length];
      }

      if (kitDeliverableAt) {
        item.properties[theme.translations.cart_deliverable_at] = kitDeliverableAt;
      }

      return item;
    });

    const data = {
      items,
    };

    return JSON.stringify(data);
  }

  async function getCart() {
    try {
      const response = await fetch(theme.routes.cart);
      if (!response.ok) throw new Error();

      const cart = await response.json();
      if (!cart) throw new Error();

      // Generic event - Used to update data like cart count etc..
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            cart,
          },
        })
      );

      return cart;
    } catch (error) {
      console.error(error.message);

      return {};
    }
  }

  async function manageCartOperations(url, event, formElement, formData = null) {
    const form = formElement || event?.target || null;
    if (!form && !formData) throw new Error();

    // Not enough support yet for event.submitter
    const button = event?.submitter || form?.querySelector('button[name="add"]:focus'); // :focus to support multiple buttons in the same form (e.g., sticky button)

    if (button?.classList.contains('klaviyo-bis-trigger')) throw new Error();

    button?.classList.add('loading');

    const finalFormData = formData instanceof FormData ? formData : new FormData(form);

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: finalFormData,
      });
      if (!response.ok) throw new Error();

      const data = await response.json();
      if (!data) throw new Error();

      await getCart();

      button?.classList.remove('loading');
      window.modals.cart.open();

      return data;
    } catch (error) {
      console.error(error.message);

      return {};
    }
  }

  async function addToCart(event) {
    event.preventDefault();

    const url = theme.routes.cart_add;
    const product = await manageCartOperations(url, event);
    if (!product) return;

    publishProductAddedToCart(product);

    // Seems only used by spoteffects tracking at the moment
    document.dispatchEvent(
      new CustomEvent('cart:added', {
        detail: {
          product,
          quantity: 1,
        },
      })
    );
  }

  async function addKitToCart(event) {
    event.preventDefault();

    const form = event.target;
    if (!form) throw new Error();

    // Not enough support yet for event.submitter
    const button = event.submitter || form.querySelector('button[name="add"]:focus'); // :focus to support multiple buttons in the same form (e.g., sticky button)

    button?.classList.add('loading');

    const formData = getKitFormData(form);

    try {
      const response = await fetch(theme.routes.cart_add, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: formData,
      });
      if (!response.ok) throw new Error();

      const data = await response.json();
      if (!data) throw new Error();

      // Publish regular add to cart event for optional items/accessories
      const optionalItemsOrAccessory = data.items.filter(
        (item) => item.properties?._KitOptionalProductStandardPrice
      );
      optionalItemsOrAccessory.forEach((item) => publishProductAddedToCart(item));

      await getCart();

      button?.classList.remove('loading');
      window.modals.cart.open();
    } catch (error) {
      console.error(error.message);
    }
  }

  function updateItem(event, form, formData = null) {
    event?.preventDefault();

    const url = theme.routes.cart_update;
    return manageCartOperations(url, event, form, formData);
  }

  function removeItem(event, product) {
    event.preventDefault();

    const url = theme.routes.cart_change;
    manageCartOperations(url, event);

    publishProductRemovedFromCart(product);
  }

  return {
    getCart,
    addToCart,
    addKitToCart,
    updateItem,
    removeItem,
  };
})();

export const {getCart, addToCart, addKitToCart, updateItem, removeItem} = labCart;
